// @ts-ignore
import ChatActions from 'chat/actions/ChatActions';
import Button, { ButtonColor } from 'components/ButtonDeprecated';
import ConfirmDialog from 'components/ConfirmDialog';
import Glyph from 'components/Glyph';
// @ts-ignore
import Chat from 'entities/Chat';
import * as React from 'react';
import Modal from 'react-modal';

export type Props = { chat: Chat; buttonClassName: string };
type State = { confirmDialogOpen: boolean };

class LeaveChatButton extends React.Component<Props, State> {
  state = {
    confirmDialogOpen: false,
  };

  hideModal = () => this.setState({ confirmDialogOpen: false });

  showModal = () => this.setState({ confirmDialogOpen: true });

  renderLeaveButton() {
    const { chat } = this.props;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.confirmDialogOpen}>
          <ConfirmDialog
            eventScreenName="LeaveChatButton"
            glyph="caution"
            glyphColor="apple"
            title="Leave this conversation?"
            subtext="You won’t receive new messages in this conversation."
            onConfirm={() => ChatActions.leaveChat(chat)}
            onRequestHide={this.hideModal}
          />
        </Modal>
        <Button
          data-test="leave-conversation-button"
          className={this.props.buttonClassName}
          level="text"
          color={ButtonColor.apple}
          onClick={this.showModal}>
          <Glyph name="close" data-test-selector="conversation-sidebar-leave-chat-button" />
          <span>Leave this conversation</span>
        </Button>
      </React.Fragment>
    );
  }
  render() {
    const { chat } = this.props;
    if (!chat.canLeave()) {
      return null;
    }
    return <div className="LeaveChatButton">{this.renderLeaveButton()}</div>;
  }
}
export default LeaveChatButton;
